import './Platform.less';

import { Layout } from 'antd';
import Profile from 'app/Layout/Header/Profile';

import { LoadingOutlined } from '@ant-design/icons';
import { useAppSelector } from 'app/hooks';
import classNames from 'classnames';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { isPlatformOrg } from 'domains/orgDomain';
import { useTranslation } from 'react-i18next';
import { canVisitStore } from 'utils/rbac';

const Header = () => {
  const orgId = useAppSelector((state) => state.app.orgId);
  const orgs = useAppSelector((state) => state.org.list);
  const loading = useAppSelector((state) => state.loading.effects.org.getOrgs);
  const user = useAppSelector((state) => state.app.user);
  const { t } = useTranslation();

  const org = orgs.find((item) => item.id === orgId);

  return (
    <Layout.Header className="platform-header">
      <h3
        className={classNames('platform-header-title', {
          'org-site': org && !isPlatformOrg(org),
        })}
      >
        {loading && orgs.length === 0 ? (
          <LoadingOutlined />
        ) : (
          org?.name || user?.orgName || t('platform.sider.platformTitle')
        )}
      </h3>
      <RevxFlexLayout>
        {canVisitStore(user) && (
          <a
            href="/workspace"
            target="_blank"
            className="platform-header-site-link"
          >
            <div>{t('platform.orgSite')}</div>
          </a>
        )}
        <Profile />
      </RevxFlexLayout>
    </Layout.Header>
  );
};

export default Header;
